import { HttpMethod } from '../types.js';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_SyncManager = {
    v1: {
        smartSync: { method: HttpMethod.POST, path: 'v1/db-api/smart-sync', timeout: Minute },
    }
};
//# sourceMappingURL=apis.js.map